import React from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useAppContext } from "store/context";
import Settings from "./components/Settings";

const SettingsContainer = ({ open, handleClose, merchant_id }) => {
  const { firebase } = useAppContext();
  const [devices, loading] = useCollectionData(
    firebase.firestore().collection("devices").where("merchant_id", "==", merchant_id)
  );

  if (loading || !devices) {
    return null;
  }

  return <Settings open={open} handleClose={handleClose} devices={devices} merchant_id={merchant_id} />;
};

export default SettingsContainer;
